import { Component, Input, OnChanges } from 'angular-ts-decorators';
import { faSort, faSortDown, faSortUp } from '@fortawesome/pro-solid-svg-icons';
import { SwChange } from '../../classes/sw-change';

/**
 * Component to display sort arrows next to table headers.
 * # Attributes:
 * * sw-change - callback function
 * * reset-stream - accepts streams that emits everytime when the state has to be reset
 *
 * # Deprecated attributes:
 * * key - key that is updated
 * * title - attribute that can be used instead of tag content
 * # Example
 * <pre>
 *   <sw-sort sw-change="$ctrl.onUpdate('lastName', direction)">"{{'core.user_name' | translate}}" </sw-sort>
 * </pre>
 *
 * The method provided in `update` param is called everytime when the value is changed,
 * with:
 * * direction equal to 'asc', 'desc', or undefined
 * * reverse equal to false, true, or undefined
 * * key equal to the same (deprecated) parameter
 */
@Component({
  selector: 'swSort',
  transclude: true,
  template: require('./sw-sort.html').default,
})
export class SwSortComponent extends SwChange implements OnChanges {
  @Input('=') resetStream;
  @Input('@') key: string;
  // deprecated - put the label inside the tag
  @Input('@') title: string;

  faSort = faSort;
  faSortDown = faSortDown;
  faSortUp = faSortUp;
  direction: string;

  constructor() {
    'ngInject';
    super();
  }

  ngOnChanges() {
    if (this.resetStream && angular.isFunction(this.resetStream.subscribe)) {
      this.resetStream.subscribe(() => {
        this.direction = undefined;
      });
    }
  }

  changeSortDirection() {
    if (!this.direction) {
      this.direction = 'asc';
    } else if (this.direction === 'asc') {
      this.direction = 'desc';
    } else {
      this.direction = undefined;
    }

    this.change({
      key: this.key,
      direction: this.direction,
      reverse: this.direction === 'asc',
    });
  }
}
